<script setup lang="ts">

    import { defineProps, defineEmits, reactive, ref, onMounted, computed, watch } from "vue";
    
    const props = defineProps({
        modelValue: { type: String, default: null },
        id: { type: String, required: true },
        classesNames: { type: String, default: '' },
    });
    const emit = defineEmits(['update:modelValue']);
    const formData = reactive({
        indicatif: '+225',
        telephone: null as string | null,
    });
    const countries = [
        { name: 'États-Unis', code: 'US', dial: '+1' },
        { name: 'Canada', code: 'CA', dial: '+1' },
        { name: 'Sénégal', code: 'SN', dial: '+221' },
        { name: 'Mali', code: 'ML', dial: '+223' },
        { name: 'Guinée', code: 'GN', dial: '+224' },
        { name: 'Côte d’Ivoire', code: 'CI', dial: '+225' },
        { name: 'Burkina Faso', code: 'BF', dial: '+226' },
        { name: 'Niger', code: 'NE', dial: '+227' },
        { name: 'Togo', code: 'TG', dial: '+228' },
        { name: 'Bénin', code: 'BJ', dial: '+229' },
        { name: 'Ghana', code: 'GH', dial: '+233' },
        { name: 'Nigeria', code: 'NG', dial: '+234' },
        { name: 'Rwanda', code: 'RW', dial: '+250' },
        { name: 'Éthiopie', code: 'ET', dial: '+251' },
        { name: 'Kenya', code: 'KE', dial: '+254' },
        { name: 'Tanzanie', code: 'TZ', dial: '+255' },
        { name: 'Afrique du Sud', code: 'ZA', dial: '+27' },
        { name: 'Belgique', code: 'BE', dial: '+32' },
        { name: 'France', code: 'FR', dial: '+33' },
        { name: 'Luxembourg', code: 'LU', dial: '+352' },
        { name: 'Suisse', code: 'CH', dial: '+41' },
        { name: 'Allemagne', code: 'DE', dial: '+49' },
        { name: 'Mexique', code: 'MX', dial: '+52' },
        { name: 'Brésil', code: 'BR', dial: '+55' },
        { name: 'Japon', code: 'JP', dial: '+81' },
        { name: 'Chine', code: 'CN', dial: '+86' },
        { name: 'Inde', code: 'IN', dial: '+91' },
        { name: 'Émirats Arabes Unis', code: 'AE', dial: '+971' },
    ];

    watch(props, () => {
        if (props.modelValue) {
            const fullNumber = props.modelValue as string;
            for (const country of countries) {
                if (fullNumber.startsWith(country.dial)) {
                    formData.indicatif = country.dial;
                    formData.telephone = fullNumber.slice(country.dial.length);
                    break;
                }
            }
        }
    }, { deep: true });

    
    watch(formData, () => {
        emit('update:modelValue', `${formData.indicatif}${formData.telephone}`);
    }, { deep: true });
</script>

<style scoped>
.form-field-with-prefix {
    padding-left: 100px;
    position: relative;
}
.form-input-prefix {
    position: absolute;
    left: 0;
    width: 100px;
    height: 100%;
    font-size: 1rem;
    line-height: 1rem;
    color: var(--component-text);
    font-weight: 600;
    background-color: transparent;
    border: none;
    outline: none;
    padding-left: 15px;
}
</style>

<template>
    <div class="form-field-floating reactive form-field-with-prefix" :class="props.classesNames">
        <select class="form-input-prefix" v-model="formData.indicatif" name="indicatif" id="indicatif">
            <option v-for="country in countries" :key="country.code" :value="country.dial">
                {{ country.dial }} ({{ country.code }})
            </option>
        </select>
        <input type="text" class="form-input" v-model="formData.telephone" name="telephone" id="telephone" placeholder="">
        <label for="telephone">Téléphone <b class="color-danger">*</b></label>
    </div>
</template>